import { IRechargePopupProps } from '@/pages/recharge/rechargePopup';
import { createAction } from '@reduxjs/toolkit';

export const openRechargePopupAction = createAction<IRechargePopupProps>('recharge/open');
